module.exports = __webpack_public_path__ + "img/coupon_detail_2@2x.f608989e.svg";